export default "__VITE_ASSET__9a2bc4ec__"